import { ManagerRole } from '../../../../../../hooks/auth/usePermissions';

export default {
  form: {
    title: 'Tilføj manager',
    first_name: {
      label: 'Fornavn',
      placeholder: 'Walter',
    },
    last_name: {
      label: 'Efternavn',
      placeholder: 'White',
    },
    city: {
      label: 'By',
      placeholder: 'Bonn',
    },
    email: {
      label: 'E-mail',
      placeholder: 'thedanger@foodamigos.io',
    },
    roles: {
      label: 'Rolle',
      placeholder: 'Vælg rolle',
      // Add-form label for store_admin sent with as_owner; other store admins keep "Admin".
      owner_option: 'Ejer',
      options: {
        [ManagerRole.Admin]: 'Admin',
        [ManagerRole.Reseller]: 'Forhandler',
        [ManagerRole.SalesManager]: 'Salgsleder',
        [ManagerRole.SalesLeadership]: 'Salgschef',
        [ManagerRole.ContentManager]: 'Indholdsmanager',
        [ManagerRole.OnboardingManager]: 'Onboarding-manager',
        [ManagerRole.MobileAppsManager]: 'Mobilapp-manager',
        [ManagerRole.StoreAdmin]: 'Admin',
        [ManagerRole.StoreEmployee]: 'Medarbejder',
        [ManagerRole.StoreOperator]: 'Operatør',
        [ManagerRole.SDR]: 'SDR',
      },
      description: {
        [ManagerRole.StoreOperator]:
          '<strong>Operatør:</strong> Fuld adgang til salg, menu, topvarer, åbningstider, gavekort, reservationer og rapporter for tildelte virksomheder.',
        [ManagerRole.StoreEmployee]:
          '<strong>Medarbejder:</strong> Begrænset adgang kun til reservationer og gavekort.',
        [ManagerRole.StoreAdmin]:
          '<strong>Ejer:</strong> Fuld adgang til én restaurant, inklusive storefront, skatteindstillinger, marketing og teamadministration. Modtager en e-mail med sit login. Én ejer pr. restaurant, og andre teammedlemmer kan ikke redigere eller fjerne vedkommende.',
      },
    },
    companies: {
      label: 'Virksomheder',
      placeholder: 'Vælg virksomheder',
      owner_placeholder: 'Vælg restaurant',
      has_owner: 'Har en ejer',
    },
  },
  fields: {
    email: 'E-mail',
    name: 'Navn',
    roles: 'Rolle',
    created_at: 'Oprettet',
    actions: 'Handlinger',
    companies: 'Virksomheder',
    status: 'Status',
  },
  tags: {
    owner: 'Ejer',
    operator: 'Operatør',
    employee: 'Medarbejder',
  },
  no_owner: {
    title: '{{restaurant}} har ingen ejer',
    description: 'Alt, der kræver ejeren, venter, til der er valgt en.',
  },
  search: {
    placeholder: 'Søg efter navn eller e-mail',
  },
  buttons: {
    add_manager: 'Tilføj manager',
    actions: 'Handlinger',
    view_dashboard: 'Se dashboard som denne manager',
    login_as_manager: 'Log ind som denne manager',
    delete: 'Slet denne manager',
    resend_owner_invite: 'Send ejerinvitationen igen',
    change_owner: 'Fjern {{name}} som ejer',
    delete_named: 'Slet {{name}}',
    choose_owner: 'Vælg en ejer',
  },
  modals: {
    delete_manager: {
      title: 'Er du sikker på, at du vil slette manageren {{email}}?',
    },
    update_manager: {
      title: 'Er du sikker på, at du vil opdatere manageren {{email}}?',
    },
    resend_owner_invite: {
      title: 'Send invitationen igen til {{email}}?',
      description: 'Ejeren får en ny adgangskode på e-mail. Den nuværende adgangskode holder op med at virke.',
    },
  },
  toasts: {
    successfully_created_manager: 'Manageren er oprettet',
    owner_invited: '{{email}} er inviteret som restaurantens ejer og modtager sit login via e-mail.',
    failed_to_load_data: 'Data kunne ikke indlæses, opdater siden',
    failed_to_create_manager: 'Manageren kunne ikke oprettes',
    failed_to_create_magic_link: 'Magisk link kunne ikke oprettes',
    failed_to_delete_manager: 'Manageren kunne ikke slettes',
    manager_got_deleted: 'Manageren er slettet',
    successfully_updated_manager: 'Manageren er opdateret',
    failed_to_update_manager: 'Manageren kunne ikke opdateres',
    owner_invite_resent: 'Invitationen blev sendt til {{email}} igen med en ny adgangskode.',
    owner_invite_resend_cooling_down:
      'Invitationen er lige blevet sendt igen. Vent et par minutter, før du sender den igen.',
    failed_to_resend_owner_invite: 'Invitationen kunne ikke sendes igen',
    owner_changed: '{{name}} er nu ejer',
    owner_changed_new: '{{name}} er nu ejer. Login sendt til {{email}}',
    owner_removed: '{{name}} er ikke længere ejer',
  },
};
